/**
 * OE-DDX-UI-001 §1.18 / OA-03 — UI observability contract.
 * Architecture only: console + in-memory sink. No telemetry provider.
 */

export type ObsCategory =
  | "navigation"
  | "error"
  | "action"
  | "timing";

export type ObsEvent = {
  category: ObsCategory;
  name: string;
  at: number;
  detail?: Record<string, unknown>;
};

const sink: ObsEvent[] = [];

export function emitObs(
  category: ObsCategory,
  name: string,
  detail?: Record<string, unknown>,
): void {
  const event: ObsEvent = {
    category,
    name,
    at: Date.now(),
    ...(detail ? { detail } : {}),
  };
  sink.push(event);
  // Minimal sink — sufficient for M-6 validation (§1.9 item 14).
  // eslint-disable-next-line no-console
  console.debug("[ddx-obs]", event);
}

export function getObsEvents(): readonly ObsEvent[] {
  return sink;
}

export function clearObsEvents(): void {
  sink.length = 0;
}
